module.exports = function isFunction(x) {
  return typeof x === 'function';
};


//////////////////
// WEBPACK FOOTER
// /data/www/SGDBackend-Nex2/~/tcomb/lib/isFunction.js
// module id = 18
// module chunks = 0